// extracted by mini-css-extract-plugin
export var box = "FormerTrainees-module--box--0189a";
export var box_md = "FormerTrainees-module--box_md--4af37";
export var box_xmd = "FormerTrainees-module--box_xmd--6056b";
export var box_flex = "FormerTrainees-module--box_flex--59aff";
export var box_lg = "FormerTrainees-module--box_lg--ad3de";
export var box_sm = "FormerTrainees-module--box_sm--523e3";
export var box_outer = "FormerTrainees-module--box_outer--df9b8";
export var box_whiteBg = "FormerTrainees-module--box_white-bg--74bd2";
export var box_noMarginBottom = "FormerTrainees-module--box_no-margin-bottom--a9aab";
export var box_noPadding = "FormerTrainees-module--box_no-padding--f422e";
export var box_outerGray = "FormerTrainees-module--box_outer-gray--187fa";
export var box_dark = "FormerTrainees-module--box_dark--ed7c1";
export var box_zIndex = "FormerTrainees-module--box_z-index--53f5c";
export var box_zIndex6 = "FormerTrainees-module--box_z-index-6--50df0";
export var box_eventsWithLine = "FormerTrainees-module--box_events-with-line--855c6";
export var box_featuresAo = "FormerTrainees-module--box_features-ao--47381";
export var box_verticalPaddings = "FormerTrainees-module--box_vertical-paddings--ab5d6";
export var clearP = "FormerTrainees-module--clearP--332f6";
export var clearP_vc = "FormerTrainees-module--clearP_vc--9d56c";
export var layout = "FormerTrainees-module--layout--62683";
export var content = "FormerTrainees-module--content--dd90a";
export var title = "FormerTrainees-module--title--424bc";
export var sliderControls = "FormerTrainees-module--sliderControls--03845";
export var fadeInAnimation = "FormerTrainees-module--fadeInAnimation--5837d";
export var placeHolderShimmer = "FormerTrainees-module--placeHolderShimmer--01904";